export const TRIPS = 'TRIPS'
export const AVITECH = 'AVITECH'
export const  DEALERPAY='DEALERPAY'